import Effect from "../Effect";
class HighPass extends Effect {

	constructor(path, number) {
		super("HighPass", HighPass.nice_name, path, number);

		this.createParameter("frequence", {name: "Freq", min: 20, max: 4200, step: 5, scale: "log2"});

		this.createParameter("resonance", {name: "Q", min: 0, max: 11, step: 0.2});
	}

	createNodes(context) {
		this.filter = context.createBiquadFilter();

		this.filter.type = 'highpass';

		this.getParameterByName('frequence').setParam(this.filter.frequency);
		this.getParameterByName('resonance').setParam(this.filter.Q);

		return {
			connect: (node) => {
				this.filter.connect(node);
			},
			disconnect: (node) => {
				this.filter.disconnect(node);
			},
			input: this.filter
		};
	}
}

HighPass.nice_name = "High Pass";

export default HighPass;
